import { useState } from "react";

function useSection(value = null) {
    const [section, setSection] = useState(value);
    
    const setSectionTroughtEventClick = (event) => {
        const el = event.target;
        const value = el.getAttribute('data-name');
        setSection(section == value ? null : value);
    }

    return [section, setSection, setSectionTroughtEventClick];
}

export default useSection;

